import {
  FaFacebookF,
  FaYoutube,
  FaTiktok,
  FaPaperPlane,
  FaArrowRight,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const FooterSection = () => {
  return (
    <footer className="footer-section section-bg fix">
      <div className="container">
        <div className="footer-widgets-wrapper">
          <div className="row">
            {/* Footer Widget 1: Logo & Social */}
            <div
              className="col-xl-4 col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay=".2s"
            >
              <div className="single-footer-widget">
                <div className="widget-head">
                  <Link to="/">
                    <img
                      src="/logo-design24.webp"
                      alt="logo"
                    />
                  </Link>
                </div>
                <div className="footer-content">
                  <p>Mã số thuế: 1801676144 </p>
                  <p>
                    Thiết kế với đam mê, cùng nhau tạo ra những sản phẩm <br />{" "}
                    tuyệt vời.
                  </p>
                  <div className="social-icon d-flex align-items-center">
                    <a
                      href="https://www.facebook.com/www.design24.edu.vn"
                      className="icon"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebookF />
                    </a>

                    <a
                      href="https://www.youtube.com/@design2424"
                      className="icon"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaYoutube />
                    </a>
                    <a
                      href="https://www.tiktok.com/@design24_channel"
                      className="icon"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaTiktok />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer Widget 2: Quick Links */}
            <div
              className="col-xl-2 col-lg-4 col-md-6 ps-lg-3 wow fadeInUp"
              data-wow-delay=".4s"
            >
              <div className="single-footer-widget">
                <div className="widget-head">
                  <h3>Liên Kết Nhanh</h3>
                </div>
                <ul className="list-items">
                  <li>
                    <Link to="/gioi-thieu">
                      <FaArrowRight className="list-icon" /> Về Chúng Tôi
                    </Link>
                  </li>
                  <li>
                    <Link to="/dich-vu">
                      <FaArrowRight className="list-icon" /> Dịch Vụ
                    </Link>
                  </li>
                  <li>
                    <Link to="/bai-viet">
                      <FaArrowRight className="list-icon" /> Bài Viết
                    </Link>
                  </li>
                  <li>
                    <Link to="/lien-he">
                      <FaArrowRight className="list-icon" /> Liên Hệ
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Footer Widget 3: Office Info */}
            <div
              className="col-xl-3 col-lg-4 col-md-6 ps-lg-5 wow fadeInUp"
              data-wow-delay=".6s"
            >
              <div className="single-footer-widget">
                <div className="widget-head">
                  <h3>Văn Phòng</h3>
                </div>
                <div className="footer-content">
                  <p>
                    166 đường Nguyễn Văn Cừ Nối Dài, An Bình, Ninh Kiều, Cần Thơ
                  </p>
                  <div className="contact-text">
                    <h4 className="pb-3">
                      <a href="tel:0704888009">0704.888.009</a>
                    </h4>
                    <h4 className="pb-3">
                      <a href="tel:0784888009">0784.888.009</a>
                    </h4>
                    <h5>
                      <a href="mailto:design24.vn@gmail.com">
                        Design24.vn@gmail.com
                      </a>
                    </h5>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer Widget 4: Subscribe */}
            <div
              className="col-xl-3 col-lg-4 col-md-6 ps-lg-3 wow fadeInUp"
              data-wow-delay=".8s"
            >
              <div className="single-footer-widget">
                <div className="widget-head">
                  <h3>Đăng Ký Nhận Tin</h3>
                </div>
                <div className="footer-content">
                  <div className="footer-input">
                    <input
                      type="email"
                      id="email"
                      placeholder="Nhập email của bạn"
                    />
                    <button
                      className="newsletter-btn"
                      type="submit"
                    >
                      <FaPaperPlane />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-wrapper">
            <p
              className="wow fadeInUp"
              data-wow-delay=".3s"
            >
              Copyright @ Design24
            </p>
            <p
              className="wow fadeInUp"
              data-wow-delay=".5s"
            >
              Thiết kế bởi{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://design24.vn/"
              >
                design24
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
